import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ae-dr-horton",
  templateUrl: "./dream-finders-active-adult-jax.component.html",
  styleUrls: ["./dream-finders-active-adult-jax.component.scss"]
})
export class DreamFindersActiveAdultJAXComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
